<template>
    <div class="trusted-company-badge">
        <img
            :src="`${$baseUrl}mekon_trusted_logo.png`"
            :alt="$t('landingPage.trustedCompanyBadge')"
            width="50"
            height="50"
            class="trusted-company-badge__img"
        />
        <div class="trusted-company-badge__label">
            {{ ($t('landingPage.trustedCompanyBadge') || '').toUpperCase() }}
        </div>
    </div>
</template>

<script>
export default {
    name: "TrustedCompanyBadge",
};
</script>

<style scoped>
.trusted-company-badge {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
    max-width: 140px;
}
.trusted-company-badge__img {
    object-fit: contain;
}
.trusted-company-badge__label {
    font-size: 0.75rem;
    font-weight: 700;
    line-height: 1.2;
}
</style>
